/**
 * Cross-tree signal for "place an outbound call to this number".
 *
 * The voice provider lives inside the floating widget; support ticket
 * components live in the page tree. They aren't ancestor/descendant,
 * so the components can't `useContext(VoiceContextV2)` to call
 * `placeOutbound` directly. A window-level CustomEvent bridges the
 * gap: any component fires the event with a phone number, and the
 * provider — which subscribes when it mounts — handles the actual
 * Telnyx dial.
 *
 * Failure modes are intentionally silent here. If voice isn't
 * available (no widget mounted, agent offline, no Telnyx session)
 * the dispatched event has no listener and nothing happens. Callers
 * that need feedback can check `isVoiceCalloutAvailable()` first.
 */

export const VOICE_CALL_CUSTOMER_EVENT = "redo-voice-call-customer";

export interface VoiceCallCustomerDetail {
  readonly phoneNumber: string;
}

export function dispatchVoiceCallCustomer(phoneNumber: string): void {
  window.dispatchEvent(
    new CustomEvent<VoiceCallCustomerDetail>(VOICE_CALL_CUSTOMER_EVENT, {
      detail: { phoneNumber },
    }),
  );
}
